import { ApiError } from "./ApiError";

export default class InternalServerError extends ApiError {
  code = 500;
}
